/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DepartmentListResult { 
    /**
     * Department Name List.
     */
    departmentNames?: Array<string>;
}

